/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface IWhyStudentTargetHeroProps {
  title?: string;
  description?: string;
  backgroundImage?: string;
  id?: string;
  showArrow?: boolean;
  onArrowClick?: () => void;
}

const DownArrowIcon: React.FunctionComponent = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5V17M12 17L7 12M12 17L17 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WhyStudentTargetHero: React.FunctionComponent<
  IWhyStudentTargetHeroProps
> = ({
  title,
  description,
  backgroundImage,
  id,
  showArrow = true,
  onArrowClick,
}) => {
  if (!title && !description && !backgroundImage) return null;

  return (
    <div className="why-student-training-target-hero" id={id}>
      {backgroundImage ? (
        <img
          className="why-student-training-target-hero-img"
          src={backgroundImage}
          alt=""
        />
      ) : null}
      <div className="why-student-training-target-hero-text">
        {title ? (
          <h2 className="why-student-training-target-hero-title">{title}</h2>
        ) : null}
        {description ? (
          <p className="why-student-training-target-hero-desc">{description}</p>
        ) : null}
        {/*{showArrow ? (*/}
        {/*  <button*/}
        {/*    type="button"*/}
        {/*    className="why-student-training-target-hero-arrow"*/}
        {/*    onClick={onArrowClick}*/}
        {/*    aria-label="scroll to reasons"*/}
        {/*  >*/}
        {/*    <DownArrowIcon />*/}
        {/*  </button>*/}
        {/*) : null}*/}
      </div>
    </div>
  );
};

export default React.memo(WhyStudentTargetHero);
